export default __webpack_public_path__ + "static/media/material-pd.e6841d04.svg";